import moment from 'moment';

const BAGHDAD_OFFSET_MINUTES = 180;

export const OPERATIONAL_HOURS_SCHEDULE_AR = {
  title: 'أوقات العمل في طمر النهروان',
  lines: [
    '1 – 10 نيسان: 8:00 ص – 5:00 م',
    '11 – 13 نيسان: 6:00 ص – 6:00 م',
    '14 – 19 نيسان: الموقع مغلق',
    '20 نيسان فما بعد: 5:00 ص – 5:00 م',
  ],
  footer: 'الشحنات خارج هذه النوافذ تُعتبر مرفوضة ولا تُحتسب.',
};

export const OPERATIONAL_HOURS_ONE_LINER_AR =
  'فلتر ساعات العمل — طمر النهروان: ' +
  '1-10 نيسان 8:00 ص–5:00 م  |  ' +
  '11-13 نيسان 6:00 ص–6:00 م  |  ' +
  '14-19 نيسان مغلق  |  ' +
  '20 نيسان فما بعد 5:00 ص–5:00 م';

export function isWithinOperationalHours(t2String) {
  const m = moment(t2String).utcOffset(BAGHDAD_OFFSET_MINUTES, true);
  if (!m.isValid()) return false;

  const year = m.year();
  const month = m.month();
  const day = m.date();

  if (year < 2026 || (year === 2026 && month < 3)) return true;

  const windowFor = (startHour, endHour) => {
    const start = m.clone().hour(startHour).minute(0).second(0).millisecond(0);
    const end = m.clone().hour(endHour).minute(0).second(0).millisecond(0);
    return m.isSameOrAfter(start) && m.isSameOrBefore(end);
  };

  if (year === 2026 && month === 3) {
    if (day <= 10) return windowFor(8, 17);
    if (day <= 13) return windowFor(6, 18);
    if (day <= 19) return false;
    return windowFor(5, 17);
  }

  return windowFor(5, 17);
}
